import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ExcelMaterialImport_ShellService } from './ExcelMaterialImport.shell.service';
import { ExcelMaterialImport_OperationService } from './ExcelMaterialImport.operation.service';
import { ExcelMaterialImport_DatasourceService } from './ExcelMaterialImport.datasource.index';
import { ExcelMaterialImport_FlowService } from './ExcelMaterialImport.flow.index';
import { ExcelMaterialImport_ReportService } from './ExcelMaterialImport.report.index';
import { ExcelMaterialImport_LocalizationService } from './ExcelMaterialImport.localization.service';
import { ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService } from './ExcelMaterialImport.excel_materials_packagings_import_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ExcelMaterialImport.frontend.types'
import { $frontendTypes as $types} from './ExcelMaterialImport.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ExcelMaterialImport_owners_dd_singleComponent } from './ExcelMaterialImport.owners_dd_single.component'
import { ExcelMaterialImport_projects_dd_singleComponent } from './ExcelMaterialImport.projects_dd_single.component'
import { ExcelMaterialImport_material_packagings_dd_singleComponent } from './ExcelMaterialImport.material_packagings_dd_single.component'
import { ExcelMaterialImport_yn_dd_singleComponent } from './ExcelMaterialImport.yn_dd_single.component'
import { ExcelMaterialImport_measurement_units_dd_singleComponent } from './ExcelMaterialImport.measurement_units_dd_single.component'


interface IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity {
  MaterialId?: number, PackagingId?: number, DimensionUomId?: number, Height?: number, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, SubPackagingId?: number, SubPackagingQuantity?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } } }, Packaging?: { Id?: number, ShortName?: string }, SubPackaging?: { Id?: number, ShortName?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, DimensionsUom?: { Short_name?: string }}



class ExcelMaterialImport_excel_materials_packagings_import_gridComponentRowModel extends GridRowModel {
  grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent;
  entity: IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    owner_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    project_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    lookupcode_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    uom_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    sub_packaging_uom_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    sub_packaging_quantity_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    upc_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_ready_to_ship_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_tie_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_high_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    net_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_uom_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    length_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    width_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    dimension_uom_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    net_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    volume_uom_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
  });

  override cells = {
    Id: null,
    error: null,
    owner: null,
    project: null,
    lookupcode: null,
    uom: null,
    sub_packaging_uom: null,
    sub_packaging_quantity: null,
    upc: null,
    is_ready_to_ship: null,
    pallet_tie: null,
    pallet_high: null,
    net_weight: null,
    shipping_weight: null,
    weight_uom: null,
    length: null,
    width: null,
    height: null,
    dimension_uom: null,
    net_volume: null,
    shipping_volume: null,
    volume_uom: null,
  }

  get $fields_owner_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_owner_selector_inParams_projectId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.cells.project.editControl.value;
    
    return expr;
  }
  get $fields_project_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_weight_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 3;
    
    return expr;
  }
  get $fields_dimension_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_volume_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 2;
    
    return expr;
  }


  constructor(
    grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ExcelMaterialImport_ShellService,
private $datasources: ExcelMaterialImport_DatasourceService,
private $flows: ExcelMaterialImport_FlowService,
private $reports: ExcelMaterialImport_ReportService,
private $localization: ExcelMaterialImport_LocalizationService,
private $operations: ExcelMaterialImport_OperationService,
private $logger: CleanupLoggerService,
private $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.error = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.error,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.owner = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.owner,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['owner_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['project_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.lookupcode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lookupcode,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['lookupcode_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['uom_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.sub_packaging_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.sub_packaging_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['sub_packaging_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.sub_packaging_quantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.sub_packaging_quantity,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['sub_packaging_quantity_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.upc = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.upc,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['upc_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.is_ready_to_ship = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.is_ready_to_ship,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['is_ready_to_ship_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.pallet_tie = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pallet_tie,
      new TextModel(null, null,  'number', '0', null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_tie_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.pallet_high = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pallet_high,
      new TextModel(null, null,  'number', '0', null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_high_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.net_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.net_weight,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['net_weight_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.shipping_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_weight,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_weight_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.weight_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['weight_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.length,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['length_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.width,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['width_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.height,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['height_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.dimension_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.dimension_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['dimension_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.net_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.net_volume,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['net_volume_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.shipping_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_volume,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_volume_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.volume_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.volume_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['volume_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    
  }

  async $initializeExisting(entity: IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_new_row();
    }

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'MaterialId',this.entity.MaterialId);
    set($resultKey, 'PackagingId',this.entity.PackagingId);
    const inParams = {
      $keys:[$resultKey],
      materialId:  null ,
      packagingId:  null ,
    };
    const data = await this.$datasources.ExcelMaterialImport.ds_material_packagings_import_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $utils.isDefined($row.entity?.MaterialId) ? `${$row.entity.MaterialId}:${$row.entity?.PackagingId}` : '';
    (this.cells.owner.displayControl as TextModel).text = $row.entity.Material?.Project?.Owner?.LookupCode;
    (this.cells.owner.editControl as SelectBoxModel).reset($row.entity.Material?.Project?.OwnerId);
    (this.cells.project.displayControl as TextModel).text = $row.entity?.Material?.Project?.LookupCode;
    (this.cells.project.editControl as SelectBoxModel).reset($row.entity?.Material?.ProjectId);
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity?.Material?.LookupCode;
    (this.cells.lookupcode.editControl as TextBoxModel).reset($row.entity?.Material?.LookupCode);
    (this.cells.uom.displayControl as TextModel).text = $row.entity?.Packaging?.ShortName;
    (this.cells.uom.editControl as SelectBoxModel).reset($row.entity?.PackagingId);
    (this.cells.sub_packaging_uom.displayControl as TextModel).text = $row.entity?.SubPackaging?.ShortName;
    (this.cells.sub_packaging_uom.editControl as SelectBoxModel).reset($row.entity?.SubPackagingId);
    (this.cells.sub_packaging_quantity.displayControl as TextModel).text = $row.entity?.SubPackagingQuantity?.toString();
    (this.cells.sub_packaging_quantity.editControl as NumberBoxModel).reset($row.entity?.SubPackagingQuantity);
    (this.cells.upc.displayControl as TextModel).text = $row.entity?.UpcCode;
    (this.cells.upc.editControl as TextBoxModel).reset($row.entity?.UpcCode);
    (this.cells.is_ready_to_ship.displayControl as TextModel).text = $row.entity?.UseAsShippingContainer ? 'Y' : 'N';
    (this.cells.is_ready_to_ship.editControl as SelectBoxModel).reset($row.entity?.UseAsShippingContainer ? 'Y' : 'N');
    (this.cells.pallet_tie.displayControl as TextModel).text = $row.entity?.PalletTie?.toString();
    (this.cells.pallet_tie.editControl as NumberBoxModel).reset($row.entity?.PalletTie);
    (this.cells.pallet_high.displayControl as TextModel).text = $row.entity?.PalletHigh?.toString();
    (this.cells.pallet_high.editControl as NumberBoxModel).reset($row.entity?.PalletHigh);
    (this.cells.net_weight.displayControl as TextModel).text = $row.entity?.Weight?.toString();
    (this.cells.net_weight.editControl as NumberBoxModel).reset($row.entity?.Weight);
    (this.cells.shipping_weight.displayControl as TextModel).text = $row.entity?.ShippingWeight?.toString();
    (this.cells.shipping_weight.editControl as NumberBoxModel).reset($row.entity?.ShippingWeight);
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity?.WeightUom?.Short_name;
    (this.cells.weight_uom.editControl as SelectBoxModel).reset($row.entity?.WeightUomId);
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.length.editControl as NumberBoxModel).reset($row.entity.Length);
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.width.editControl as NumberBoxModel).reset($row.entity.Width);
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.height.editControl as NumberBoxModel).reset($row.entity.Height);
    (this.cells.dimension_uom.displayControl as TextModel).text = $row.entity.DimensionsUom?.Short_name;
    (this.cells.dimension_uom.editControl as SelectBoxModel).reset($row.entity.DimensionUomId);
    (this.cells.net_volume.displayControl as TextModel).text = $row.entity.Volume?.toString();
    (this.cells.net_volume.editControl as NumberBoxModel).reset($row.entity.Volume);
    (this.cells.shipping_volume.displayControl as TextModel).text = $row.entity.ShippingVolume?.toString();
    (this.cells.shipping_volume.editControl as NumberBoxModel).reset($row.entity.ShippingVolume);
    (this.cells.volume_uom.displayControl as TextModel).text = $row.entity.VolumeUom?.Short_name;
    (this.cells.volume_uom.editControl as SelectBoxModel).reset($row.entity.VolumeUomId);

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_init_new_row(event = null) {
    return this.on_init_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_new_rowInternal(
    $row: ExcelMaterialImport_excel_materials_packagings_import_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_materials_packagings_import_grid.on_init_new_row');
  
  // Initialize read only cells if a user manually adds a new row.
  $row.cells.uom.editControl.readOnly = false;
  $row.cells.project.editControl.readOnly = false;
  
  
  
  
  
  
  
  
  
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: ExcelMaterialImport_excel_materials_packagings_import_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_materials_packagings_import_grid.on_save_existing_row');
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $row.cells.lookupcode.editControl.value
  );
  
  if (allRequiredFieldHaveValue === false) {
      $shell.ExcelMaterialImport.openErrorDialog('Save', 'Missing Required fields');
      throw new Error('Missing Required fields'); // to prevent displayMode 
  }
  
  const payload: any = {};
  
  if ($row.cells.lookupcode.editControl.isChanged) {
      payload.LookupCode = $row.cells.lookupcode.editControl.value;
  }
  // Update material packaging
  let payloadPackage: any = {};
  
  
  
  if ($row.cells.upc.editControl.isChanged) {
      payloadPackage.UpcCode = $row.cells.upc.editControl.value;
  }
  if ($row.cells.net_weight.editControl.isChanged) {
      payloadPackage.Weight = parseFloat($row.cells.net_weight.editControl.value);
  }
  if ($row.cells.shipping_weight.editControl.isChanged) {
      payloadPackage.ShippingWeight = parseFloat($row.cells.shipping_weight.editControl.value);
  }
  if ($row.cells.pallet_tie.editControl.isChanged) {
      payloadPackage.PalletTie = parseInt($row.cells.pallet_tie.editControl.value);
  }
  if ($row.cells.pallet_high.editControl.isChanged) {
      payloadPackage.PalletHigh = parseInt($row.cells.pallet_high.editControl.value);
  }
  if ($row.cells.net_volume.editControl.isChanged) {
      payloadPackage.Volume = parseFloat($row.cells.net_volume.editControl.value);
  }
  if ($row.cells.shipping_volume.editControl.isChanged) {
      payloadPackage.ShippingVolume = parseFloat($row.cells.shipping_volume.editControl.value);
  }
  if ($row.cells.length.editControl.isChanged) {
      payloadPackage.Length = parseFloat($row.cells.length.editControl.value);
  }
  if ($row.cells.width.editControl.isChanged) {
      payloadPackage.Width = parseFloat($row.cells.width.editControl.value);
  }
  if ($row.cells.height.editControl.isChanged) {
      payloadPackage.Height = parseFloat($row.cells.height.editControl.value);
  }
  if ($row.cells.weight_uom.editControl.isChanged) {
      payloadPackage.WeightUomId = parseFloat($row.cells.weight_uom.editControl.value);
  }
  if ($row.cells.dimension_uom.editControl.isChanged) {
      payloadPackage.DimensionUomId = parseFloat($row.cells.dimension_uom.editControl.value);
  }
  if ($row.cells.volume_uom.editControl.isChanged) {
      payloadPackage.VolumeUomId = parseFloat($row.cells.volume_uom.editControl.value);
  }
  if ($row.cells.is_ready_to_ship.editControl.isChanged) {
      payloadPackage.UseAsShippingContainer = $row.cells.is_ready_to_ship.editControl.value === 'Y' ? true : false;
  }
  
  
  
  try {
      const materialId = $row.entity.MaterialId;
      await $flows.Utilities.crud_update_flow({ entitySet: 'MaterialsPackagingsLookup', id: materialId, entity: payload });
      await $flows.Utilities.crud_update_dual_pk_flow({ 
          entitySet: 'MaterialsPackagingsLookup', 
          pk1String: 'MaterialId', 
          pk1: materialId, 
          pk2String: 'PackagingId', 
          pk2: $row.entity.PackagingId, 
          entity: payloadPackage });
  
      await $row.refresh();
      // Lock down read only cells
      $row.cells.uom.editControl.readOnly = true;
      $row.cells.project.editControl.readOnly = true;
  }
  catch (error) {
      $shell.ExcelMaterialImport.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  }
  
  }
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: ExcelMaterialImport_excel_materials_packagings_import_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_materials_packagings_import_grid.on_save_new_row');
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $row.cells.lookupcode.editControl.value
  );
  
  if (allRequiredFieldHaveValue === false) {
      $shell.ExcelMaterialImport.openErrorDialog('Save', 'Missing Required fields');
      throw new Error('Missing Required fields'); // to prevent displayMode 
  } else {
  
      try {
          var errors = ''
          $row.entity.Material = {Id: null, LookupCode: $row.cells.lookupcode.editControl.value, ProjectId: $row.cells.project.editControl.value}
          var projectId = $row.entity.Material.ProjectId;
          const materials = (await $datasources.ExcelMaterialImport.ds_get_materials_by_lookupcodes.get({ materialLookupcodes: [$row.cells.lookupcode.editControl.value] })).result;
          // Get Material
          let material = materials.find(m => m.LookupCode.toUpperCase().trim() == $row.cells.lookupcode.editControl.value.toUpperCase().trim() && m.ProjectId === $row.entity.Material.ProjectId);
  
          if (!$utils.isDefined(material)) {
              errors += 'Material not found';
              $row.cells.error.displayControl.text = errors;
              throw new Error('Material not found');
          }
  
          $row.cells.error.displayControl.text = '';
  
          //Create material packaging
  
          var Length = null
          var Width = null
          var Height = null
          var netWeight = null
          var netVolume = null
          var shippingWeight = null
          var shippingVolume = null
  
          if ($utils.isDefined($row.cells.length.editControl.value)) {
              Length = $row.cells.length.editControl.value;
          } else {
              Length = 1
          }
  
          if ($utils.isDefined($row.cells.width.editControl.value)) {
              Width = $row.cells.width.editControl.value;
          } else {
              Width = 1
          }
  
          if ($utils.isDefined($row.cells.height.editControl.value)) {
              Height = $row.cells.height.editControl.value;
          } else {
              Height = 1
          }
  
          if ($utils.isDefined($row.cells.net_weight.editControl.value)) {
              netWeight = $row.cells.net_weight.editControl.value;
          } else {
              netWeight = 1
          }
  
          if ($utils.isDefined($row.cells.net_volume.editControl.value)) {
              netVolume = $row.cells.net_volume.editControl.value;
          } else {
              netVolume = 1
          }
  
          if ($utils.isDefined($row.cells.shipping_weight.editControl.value)) {
              shippingWeight = $row.cells.shipping_weight.editControl.value
          } else {
              shippingWeight = 1
          }
  
          if ($utils.isDefined($row.cells.shipping_volume.editControl.value)) {
              shippingVolume = $row.cells.shipping_volume.editControl.value;
          } else {
              shippingVolume = 1
          }
  
          var upc = null;
          if ($utils.isDefined($row.cells.upc.editControl.value)) {
              upc = $row.cells.upc.editControl.value.toString();
          }
  
          // Get BasePackagingQuantity
          let basePackagingQuantity = $row.cells.sub_packaging_quantity.editControl.value;
          let basePackagingId = material.PackagingLookups.find(m => m.IsBasePackaging).PackagingId;
          let targetPackagingId = $row.cells.sub_packaging_uom.editControl.value;
          while (targetPackagingId !== basePackagingId) {
              // Get Child Packaging
              let existingPackaging = material.PackagingLookups.find(p => p.PackagingId === targetPackagingId);
  
              if ($utils.isDefined(existingPackaging)) {
                  basePackagingQuantity *= existingPackaging.SubPackagingQuantity;
                  targetPackagingId = existingPackaging.SubPackagingId;
              }
              // else if (targetPackagingId === $row.cells.sub_packaging_uom.editControl.value) {
              //     basePackagingQuantity *= $row.cells.sub_packaging_quantity.editControl.value;
              //     targetPackagingId = $row.cells.uom.editControl.value;
              // }
              else {
                  errors += 'SubPackaging does not exist';
                  $row.cells.error.displayControl.text = errors;
                  throw new Error('SubPackaging does not exist');
              }
          }
          $row.entity.MaterialId = materials[0].Id;
          $row.entity.PackagingId = $row.cells.uom.editControl.value;
  
          const payloadMaterialPackaging = {
              "MaterialId": materials[0].Id,
              "PackagingId": $row.cells.uom.editControl.value,
              "IsBasePackaging": false,
              "SubPackagingId": $row.cells.sub_packaging_uom.editControl.value,
              "SubPackagingQuantity": $row.cells.sub_packaging_quantity.editControl.value,
              "BasePackagingId": basePackagingId,
              "BasePackagingQuantity": basePackagingQuantity,
  
              "AllowFractions": true,
              "AllowInSalesOrder": true,
              "AllowInPurchaseOrder": true,
              "IsReportingDefault": true,
              "IsOrderDefault": false,
              "IsLabelCompliant": false,
              "UseAsShippingContainer": $row.cells.is_ready_to_ship.editControl.value === 'Y' ? true : false,
              "DeprecatedPackaging": false,
              "AllowInMobileSales": false,
  
              "ShippingWeight": shippingWeight,
              "Weight": netWeight,
              "TareWeight": shippingWeight - netWeight,
              "WeightUomId": $row.cells.weight_uom.editControl.value,
  
              "Height": Height,
              "Width": Width,
              "Length": Length,
              "DimensionUomId": $row.cells.dimension_uom.editControl.value,
  
              "Volume": netVolume,
              "ShippingVolume": shippingVolume,
              "VolumeUomId": $row.cells.volume_uom.editControl.value,
  
              "PalletTie": $row.cells.pallet_tie.editControl.value,
              "PalletHigh": $row.cells.pallet_high.editControl.value,
  
              "UpcCode": upc
  
          };
  
          await $flows.Utilities.crud_create_flow({ entitySet: 'MaterialsPackagingsLookup', entity: payloadMaterialPackaging });
  
  
          $row.refresh();
  
          // Lock down read only cells upon creation
          $row.cells.uom.editControl.readOnly = true;
          $row.cells.project.editControl.readOnly = true;
  
      }
      catch (error) {
          $shell.ExcelMaterialImport.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  }
  
  
  
  
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ExcelMaterialImport_owners_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_projects_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_material_packagings_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_yn_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_measurement_units_dd_singleComponent),
  ],
  selector: 'ExcelMaterialImport-excel_materials_packagings_import_grid',
  templateUrl: './ExcelMaterialImport.excel_materials_packagings_import_grid.component.html'
})
export class ExcelMaterialImport_excel_materials_packagings_import_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);




  //#region Variables
  vars: { projectId?: number } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       error: new GridHeaderModel(new HeaderStyles(null, null), 'error', 'Errors', false, false, null, false),       owner: new GridHeaderModel(new HeaderStyles(null, null), 'owner', 'Owner code', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project code', false, false, null, false),       lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'lookupcode', 'Material code', true, false, null, false),       uom: new GridHeaderModel(new HeaderStyles(null, null), 'uom', 'UOM', true, false, null, false),       sub_packaging_uom: new GridHeaderModel(new HeaderStyles(null, null), 'sub_packaging_uom', 'Sub-packaging', true, false, null, false),       sub_packaging_quantity: new GridHeaderModel(new HeaderStyles(null, null), 'sub_packaging_quantity', 'Sub-packaging quantity', true, false, null, false),       upc: new GridHeaderModel(new HeaderStyles(null, null), 'upc', 'UPC', false, false, null, false),       is_ready_to_ship: new GridHeaderModel(new HeaderStyles(null, null), 'is_ready_to_ship', 'Is ready to ship', false, false, null, false),       pallet_tie: new GridHeaderModel(new HeaderStyles(null, null), 'pallet_tie', 'Pallet tie', false, false, null, false),       pallet_high: new GridHeaderModel(new HeaderStyles(null, null), 'pallet_high', 'Pallet high', false, false, null, false),       net_weight: new GridHeaderModel(new HeaderStyles(null, null), 'net_weight', 'Net weight', false, false, null, false),       shipping_weight: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_weight', 'Shipping weight', false, false, null, false),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'weight_uom', 'Weight UOM', true, false, null, false),       length: new GridHeaderModel(new HeaderStyles(null, null), 'length', 'Length', false, false, null, false),       width: new GridHeaderModel(new HeaderStyles(null, null), 'width', 'Width', false, false, null, false),       height: new GridHeaderModel(new HeaderStyles(null, null), 'height', 'Height', false, false, null, false),       dimension_uom: new GridHeaderModel(new HeaderStyles(null, null), 'dimension_uom', 'Dimension UOM', true, false, null, false),       net_volume: new GridHeaderModel(new HeaderStyles(null, null), 'net_volume', 'Net volume', false, false, null, false),       shipping_volume: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_volume', 'Shipping volume', false, false, null, false),       volume_uom: new GridHeaderModel(new HeaderStyles(null, null), 'volume_uom', 'Volume UOM', true, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ExcelMaterialImport_excel_materials_packagings_import_gridComponentRowModel[] = [];


  topToolbar = {
      linecount: new ToolModel(new ButtonModel('linecount', new ButtonStyles(null, null), false, false, false, 'Line count', '', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ExcelMaterialImport_ShellService,
    private $datasources: ExcelMaterialImport_DatasourceService,
    private $flows: ExcelMaterialImport_FlowService,
    private $reports: ExcelMaterialImport_ReportService,
    private $localization: ExcelMaterialImport_LocalizationService,
    private $operations: ExcelMaterialImport_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Material packaging import';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      materialId:  null ,
      packagingId:  null ,
    };
    try {
      const data = await this.$datasources.ExcelMaterialImport.ds_material_packagings_import_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ExcelMaterialImport_excel_materials_packagings_import_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IExcelMaterialImport_excel_materials_packagings_import_gridComponentEntity) {
    const row = new ExcelMaterialImport_excel_materials_packagings_import_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_materials_packagings_import_grid.on_excel_export');
  const wb = $event;
  
  const orderLines = [];
  
  orderLines.push({
      OwnerLookupCode: 'Required',
      ProjectLookupCode: 'Required',
      LookupCode: 'Required',
      UOM: 'EA, CS',
      SubPackaging: 'EA, CS',
      SubPackagingQuantity: '',
      UPC: '',
      IsReadyToShip: 'Y, N',
      PalletTie: '',
      PalletHigh: '',
      NetWeight: '',
      ShippingWeight: '',
      WeightUnit: 'g, kg, lb, mt, oz, T, t oz',
      Length: '',
      Width: '',
      Height: '',
      DimensionUnit: 'cm, ft, in, m',
      NetVolume: '',
      ShippingVolume: '',
      VolumeUnit: 'cu. cm., cu. ft., cu. in., cu. m., Gal, L, ml'
  
  });
  
  
  
  const ws = $utils.excel.json_to_sheet(orderLines);
  
  $utils.excel.book_append_sheet(wb, ws, 'MaterialImport');
  
  }
  on_excel_import(event = null) {
    return this.on_excel_importInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_importInternal(
    $grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_materials_packagings_import_grid.on_excel_import');
  
  
  const wb = $event;
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  
  const _batchSize = 500;
  
  $grid.topToolbar.linecount.hidden = false;
  $grid.topToolbar.linecount.control.icon = "icon datex-default-spinner";
  $grid.topToolbar.linecount.control.label = 'Extracting Data..';
  
  const Materials = $utils.excel.sheet_to_json<{
      OwnerLookupCode: string,
      ProjectLookupCode: string,
      LookupCode: string,
      UOM: string,
      SubPackaging: string,
      SubPackagingQuantity: string,
      UPC: string,
      IsReadyToShip: string,
      PalletTie: string,
      PalletHigh: string,
      NetWeight: string,
      ShippingWeight: string,
      WeightUnit: string,
      Length: string,
      Width: string,
      Height: string,
      DimensionUnit: string,
      NetVolume: string,
      ShippingVolume: string,
      VolumeUnit: string
  
  }>(ws);
  
  $grid.topToolbar.linecount.control.label = 'Preparing Data...';
  
  // Initialize grid and data
  const candidates = [];
  var linecount = 0;
  var confirmLineCount = 0;
  var totalLineCount = Materials.length;
  var distinctPackagingsToAdd: any[] = [];
  
  // Get Bulk Data
  var owners = (await getOwnersPool());
  var materials = (await getMaterialsPool())
  var packagings = (await getMaterialPackagingsPool())
  var measurementUnit = (await getMeasurementUnitsPool())
  
  for (const Material of Materials) {
  
      linecount = linecount + 1;
      $grid.topToolbar.linecount.control.label = 'Validating Line ' + linecount.toString() + ' of ' + totalLineCount.toString();
  
      var errors = '';
      if ($utils.isDefined(Material.LookupCode)) {
          var materialLookup = Material.LookupCode.toString();
      }
  
      const row = await $grid.addRow();
  
      row.entity.Material = { Id: null, LookupCode: null, ProjectId: null };
  
      // Get Owner
      let ownerId: number;
      let projectId: number;
  
      if ($utils.isDefined(Material.OwnerLookupCode)) {
          const ownerFound = owners.find(
              o => o.LookupCode.trim().toUpperCase() === Material.OwnerLookupCode.toString().trim().toUpperCase()
          );
          if ($utils.isDefined(ownerFound)) {
              let owner = ownerFound;
              ownerId = owner.Id;
  
              row.cells.owner.editControl.value = ownerId;
  
              // Get Project from Owner
              if ($utils.isDefined(Material.ProjectLookupCode)) {
                  const projectFound = owner.Projects.find(
                      p => p.LookupCode.trim().toUpperCase() === Material.ProjectLookupCode.trim().toUpperCase()
                  );
  
                  if ($utils.isDefined(projectFound)) {
                      projectId = projectFound.Id;
                      row.cells.project.editControl.value = projectId;
                      row.entity.Material.ProjectId = projectId;
                  }
                  else {
                      row.cells.project.editControl.value = null;
                      errors += 'Project does not exist' + ' : ';
                      row.cells.project.editControl.readOnly = false;
                  }
              } else {
                  errors += 'Project not provided' + ' : '
                  row.cells.project.editControl.readOnly = false;
              }
  
          }
          else {
              row.cells.owner.editControl.value = null;
              errors += 'Owner does not exist' + ' : ';
              row.cells.owner.editControl.readOnly = false;
          }
      } else {
          errors += 'Owner not provided' + ' : '
          row.cells.owner.editControl.readOnly = false;
      }
  
      // Validate Material
      if ($utils.isAllDefined(row.entity.Material.ProjectId, materialLookup)) {
          var material = materials.find(
              v => v.LookupCode.toString().toUpperCase().trim() == materialLookup.toString().toUpperCase().trim() && v.ProjectId === row.entity.Material.ProjectId
          );
          if (!$utils.isDefined(material)) {
              errors += 'Material not found for project' + ' : ';
          }
          else {
              row.entity.MaterialId = material.Id;
          }
      }
  
      // Validate Packaging
      if ($utils.isDefined(Material.UOM)) {
          let packagingFound = packagings.find(
              p => p.ShortName.toUpperCase().trim() === Material.UOM.toUpperCase().trim()
          );
          if ($utils.isDefined(packagingFound)) {
              row.cells.uom.editControl.value = packagingFound.Id;
              row.entity.PackagingId = packagingFound.Id;
  
              // Validate that packaging does not already exist for material or has already been added in file
              if (!material?.PackagingLookups?.find(p => p?.PackagingId === packagingFound.Id)) {
                  if (distinctPackagingsToAdd.find(v => v.materialId === material?.Id && v.packagingId === packagingFound.Id)) {
                      errors += 'Duplicate packaging for material in file' + ' : ';
                      row.cells.uom.editControl.readOnly = false;
                  }
                  else {
                      distinctPackagingsToAdd.push({ materialId: material?.Id, packagingId: packagingFound.Id });
                  }
              }
              else {
                  errors += 'UOM already exists for material' + ' : ';
                  row.cells.uom.editControl.readOnly = false;
              }
          }
          else {
              row.cells.uom.editControl.value = null;
              errors += 'Incorrect Uom provided' + ' : ';
              row.cells.uom.editControl.readOnly = false;
          }
      } else {
          errors += ' Uom not provided' + ' : ';
          row.cells.uom.editControl.readOnly = false;
      }
  
      // Validate SubPackagingUom
      if ($utils.isDefined(Material.SubPackaging)) {
          let packagingFound = packagings.find(
              p => p.ShortName.toUpperCase().trim() === Material.SubPackaging.toUpperCase().trim()
          );
          if ($utils.isDefined(packagingFound)) {
              // Validate Sub-Packaging exists on material
              if (material?.PackagingLookups?.find(p => p?.PackagingId === packagingFound.Id)) {
                  row.cells.sub_packaging_uom.editControl.value = packagingFound.Id;
              }
              else if (Materials.find(m =>
                  m.OwnerLookupCode.trim().toUpperCase() === Material.OwnerLookupCode.trim().toUpperCase()
                  && m.ProjectLookupCode.trim().toUpperCase() === Material.ProjectLookupCode.trim().toUpperCase()
                  && m.LookupCode.toString().trim().toUpperCase() === Material.LookupCode.toString().trim().toUpperCase()
                  && m.UOM.toString().trim().toUpperCase() === Material.SubPackaging.toString().trim().toUpperCase()
              )) {
                  row.cells.sub_packaging_uom.editControl.value = packagingFound.Id;
              }
              else {
                  row.cells.uom.editControl.value = null;
                  errors += 'SubPackaging UOM does not exist for material' + ' : ';
                  row.cells.uom.editControl.readOnly = false;
              }
          }
          else {
              row.cells.uom.editControl.value = null;
              errors += 'Invalid Sub Packaging UOM provided' + ' : ';
              row.cells.uom.editControl.readOnly = false;
          }
      } else {
          errors += ' Sub-Packaging UOM not provided' + ' : ';
          row.cells.uom.editControl.readOnly = false;
      }
  
  
      // Validate SubPackaging Quantity
      if ($utils.isDefined(Material.SubPackagingQuantity)) {
  
          if (!isNaN(Number(Material.SubPackagingQuantity))) {
              if (Number(Material.SubPackagingQuantity) > 0) {
                  row.cells.sub_packaging_quantity.editControl.value = Number(Material.SubPackagingQuantity);
              }
              else {
                  row.cells.uom.editControl.value = null;
                  errors += 'Sub Packaging Quantity must be greater than 0' + ' : ';
                  row.cells.uom.editControl.readOnly = false;
              }
          }
          else {
              row.cells.uom.editControl.value = null;
              errors += 'Invalid Sub Packaging Quantity provided' + ' : ';
              row.cells.uom.editControl.readOnly = false;
          }
      } else {
          errors += ' Sub-Packaging Quantity not provided' + ' : ';
          row.cells.uom.editControl.readOnly = false;
      }
  
      row.cells.net_weight.editControl.value = Material.NetWeight ?? null;
      row.cells.shipping_weight.editControl.value = Material.ShippingWeight ?? null;
      row.cells.upc.editControl.value = Material.UPC ?? null;
      row.cells.pallet_tie.editControl.value = Material.PalletTie ?? null;
      row.cells.pallet_high.editControl.value = Material.PalletHigh ?? null;
      row.cells.length.editControl.value = Material.Length ?? null;
      row.cells.width.editControl.value = Material.Width ?? null;
      row.cells.height.editControl.value = Material.Height ?? null;
      row.cells.net_volume.editControl.value = Material.NetVolume ?? null;
      row.cells.shipping_volume.editControl.value = Material.ShippingVolume ?? null;
      row.cells.is_ready_to_ship.editControl.value = Material.IsReadyToShip?.trim()?.toUpperCase();
  
  
  
      var volumeUomId = null;
      if ($utils.isDefined(Material.VolumeUnit)) {
          const measurementUnitFound = measurementUnit.find(
              v => v.Short_name.trim().toUpperCase() === Material.VolumeUnit.trim().toUpperCase() && v.TypeId === 2
          );
          if ($utils.isDefined(measurementUnitFound)) {
              volumeUomId = measurementUnitFound.Id;
              row.cells.volume_uom.editControl.value = volumeUomId;
          }
          else {
              row.cells.volume_uom.editControl.value = null;
              errors += 'Incorrect Volume Unit Provided' + ' : ';
          }
      } else {
          errors += 'Volume unit not provided' + ' : ';
      }
  
      var weightUomId = null;
      if ($utils.isDefined(Material.WeightUnit)) {
          const measurementUnitFound = measurementUnit.find(
              v => v.Short_name.trim().toUpperCase() === Material.WeightUnit.toString().trim().toUpperCase() && v.TypeId === 3
          );
          if ($utils.isDefined(measurementUnitFound)) {
              weightUomId = measurementUnitFound.Id;
              row.cells.weight_uom.editControl.value = weightUomId;
          }
          else {
              row.cells.weight_uom.editControl.value = null;
              errors += 'Incorrect Weight Unit Provided' + ' : ';
          }
      } else {
          errors += 'Weight unit not provided' + ' : ';
      }
  
      var dimensionUomId = null;
      if ($utils.isDefined(Material.DimensionUnit)) {
          const measurementUnitFound = measurementUnit.find(
              v => v.Short_name.trim().toUpperCase() === Material.DimensionUnit.toString().trim().toUpperCase() && v.TypeId === 1
          );
          if ($utils.isDefined(measurementUnitFound)) {
              dimensionUomId = measurementUnitFound.Id;
              row.cells.dimension_uom.editControl.value = dimensionUomId;
          }
          else {
              row.cells.dimension_uom.editControl.value = null;
              errors += 'Incorrect Dimension Unit Provided' + ' : ';
          }
      } else {
          errors += 'Dimension unit not provided' + ' : ';
      }
  
  
      if ($utils.isDefined(materialLookup)) {
          row.cells.lookupcode.editControl.value = materialLookup;
      } else {
          errors += 'LookupCode not provided ' + ' : ';
      }
  
      row.cells.error.displayControl.text = errors;
      candidates.push({ row: row, errors: errors });
  }
  
  // Validate duplicates & sort such that dependent packagings are created in order
  candidates.sort((a, b) => a.row.entity.MaterialId === b.row.entity.MaterialId ? a.row.cells.uom.editControl.value === b.row.cells.sub_packaging_uom.editControl.value ? -1 : 1 : a.row.entity.MaterialId - b.row.entity.MaterialId);
  
  console.log(candidates);
  
  var totalConfirmLineCount = candidates.length;
  
  for (const candidate of candidates) {
      const noErrors = candidate.errors === '';
      if (noErrors) {
  
          // Get Material
          let material = materials.find(m => m.LookupCode.toUpperCase().trim() == candidate.row.cells.lookupcode.editControl.value.toUpperCase().trim() && m.ProjectId === candidate.row.entity.Material.ProjectId);
  
          if (!$utils.isDefined(material)) {
              candidate.row.cells.error.displayControl.text = 'Unable to find material';
          }
          else {
  
              try {
                  confirmLineCount = confirmLineCount + 1;
                  $grid.topToolbar.linecount.control.label = 'Creating Material ' + confirmLineCount.toString() + ' of ' + totalConfirmLineCount.toString();
  
  
                  //Create material packaging
  
                  var Length: number = 0;
                  var Width: number = 0;
                  var Height: number = 0;
                  var netWeight: number = 0;
                  var netVolume: number = 0;
                  var shippingWeight: number = 0;
                  var shippingVolume: number = 0;
                  var PalletHigh: number = 0;
                  var PalletTie: number = 0;
  
                  if ($utils.isDefined(candidate.row.cells.length.editControl.value) && !isNaN(candidate.row.cells.length.editControl.value)) {
                      Length = Number(candidate.row.cells.length.editControl.value);
                  } else {
                      Length = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.width.editControl.value) && !isNaN(candidate.row.cells.width.editControl.value)) {
                      Width = Number(candidate.row.cells.width.editControl.value);
                  } else {
                      Width = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.height.editControl.value) && !isNaN(candidate.row.cells.height.editControl.value)) {
                      Height = Number(candidate.row.cells.height.editControl.value);
                  } else {
                      Height = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.net_weight.editControl.value) && !isNaN(candidate.row.cells.net_weight.editControl.value)) {
                      netWeight = Number(candidate.row.cells.net_weight.editControl.value);
                  } else {
                      netWeight = 1
                  }
  
  
                  if ($utils.isDefined(candidate.row.cells.net_volume.editControl.value) && !isNaN(candidate.row.cells.net_volume.editControl.value)) {
                      netVolume = Number(candidate.row.cells.net_volume.editControl.value);
                  } else {
                      netVolume = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.shipping_weight.editControl.value) && !isNaN(candidate.row.cells.shipping_weight.editControl.value)) {
                      shippingWeight = Number(candidate.row.cells.shipping_weight.editControl.value);
                  } else {
                      shippingWeight = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.shipping_volume.editControl.value) && !isNaN(candidate.row.cells.shipping_volume.editControl.value)) {
                      shippingVolume = Number(candidate.row.cells.shipping_volume.editControl.value);
                  } else {
                      shippingVolume = 1
                  }
  
                  var upc = null;
                  if ($utils.isDefined(candidate.row.cells.upc.editControl.value)) {
                      upc = candidate.row.cells.upc.editControl.value.toString();
                  }
  
                  if ($utils.isDefined(candidate.row.cells.pallet_tie.editControl.value) && !isNaN(candidate.row.cells.pallet_tie.editControl.value)) {
                      PalletTie = Number(candidate.row.cells.pallet_tie.editControl.value);
                  } else {
                      PalletTie = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.pallet_high.editControl.value) && !isNaN(candidate.row.cells.pallet_high.editControl.value)) {
                      PalletHigh = Number(candidate.row.cells.pallet_high.editControl.value);
                  } else {
                      PalletHigh = 1
                  }
  
                  // Get BasePackagingQuantity
                  let basePackagingQuantity = candidate.row.cells.sub_packaging_quantity.editControl.value;
                  let basePackagingId = material.PackagingLookups.find(m => m.IsBasePackaging).PackagingId;
                  let targetPackagingId = candidate.row.cells.sub_packaging_uom.editControl.value;
                  while (targetPackagingId !== basePackagingId) {
                      // Get Parent Packaging
                      let existingPackaging = material.PackagingLookups.find(p => p.PackagingId === targetPackagingId);
  
                      if ($utils.isDefined(existingPackaging)) {
                          basePackagingQuantity *= existingPackaging.SubPackagingQuantity;
                          targetPackagingId = existingPackaging.SubPackagingId;
                      }
                      else {
                          let candidatePackaging = candidates.find(c => c.row.cells.uom.editControl.value === targetPackagingId);
                          if (!$utils.isDefined(candidatePackaging.row.cells.sub_packaging_quantity.editControl.value)) {
                              throw new Error('Child packaging exists in file, but is not valid');
                          }
  
                          basePackagingQuantity *= candidatePackaging.row.cells.sub_packaging_quantity.editControl.value;
                          targetPackagingId = candidatePackaging.row.cells.sub_packaging_uom.editControl.value;
                      }
                  }
  
  
                  const payloadMaterialPackaging = {
                      "MaterialId": material.Id,
                      "PackagingId": candidate.row.cells.uom.editControl.value,
                      "IsBasePackaging": false,
                      "SubPackagingId": candidate.row.cells.sub_packaging_uom.editControl.value,
                      "SubPackagingQuantity": candidate.row.cells.sub_packaging_quantity.editControl.value,
                      "BasePackagingId": basePackagingId,
                      "BasePackagingQuantity": basePackagingQuantity,
  
                      "AllowFractions": true,
                      "AllowInSalesOrder": true,
                      "AllowInPurchaseOrder": true,
                      "IsReportingDefault": true,
                      "IsOrderDefault": false,
                      "IsLabelCompliant": false,
                      "UseAsShippingContainer": candidate.row.cells.is_ready_to_ship.editControl.value === 'Y' ? true : false,
                      "DeprecatedPackaging": false,
                      "AllowInMobileSales": false,
  
                      "ShippingWeight": shippingWeight,
                      "Weight": netWeight,
                      "TareWeight": shippingWeight - netWeight,
                      "WeightUomId": candidate.row.cells.weight_uom.editControl.value,
  
                      "Height": Height,
                      "Width": Width,
                      "Length": Length,
                      "DimensionUomId": candidate.row.cells.dimension_uom.editControl.value,
  
                      "Volume": netVolume,
                      "ShippingVolume": shippingVolume,
                      "VolumeUomId": candidate.row.cells.volume_uom.editControl.value,
  
                      "PalletTie": PalletTie,
                      "PalletHigh": PalletHigh,
  
                      "UpcCode": upc
  
                  };
  
                  await $flows.Utilities.crud_create_flow({ entitySet: 'MaterialsPackagingsLookup', entity: payloadMaterialPackaging });
  
  
                  candidate.row.refresh();
                  candidate.row.setDisplayMode();
                  candidate.row.isNew = false;
                  // Lock down read only cells upon creation
                  candidate.row.cells.uom.editControl.readOnly = true;
                  candidate.row.cells.project.editControl.readOnly = true;
  
  
              }
  
              catch (error) {
                  errors += 'Error calling calling crud Api'
                  candidate.row.cells.error.displayControl.text = errors;
  
                  $grid.topToolbar.linecount.hidden = true;
                  throw error; // to prevent displayMode 
  
              }
  
          }
  
  
      }
  
  }
  
  
  $grid.topToolbar.linecount.hidden = true;
  
  
  /*****************************************************
   * FUNCTIONS
  *****************************************************/
  async function getOwnersPool() {
      let ownerLookupCodes: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.OwnerLookupCode?.toString())).map(ol => ol.OwnerLookupCode?.toString())));
      let index = 0;
  
      while (index < ownerLookupCodes.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_owners_by_lookupcodes.get({
              ownerLookupcodes: ownerLookupCodes.slice(index, index + _batchSize)
          })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  
  async function getMaterialPackagingsPool() {
      let materialPackagings: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.UOM?.toString())).reduce((list, item) => list.concat(item.UOM, item.SubPackaging), [])));
      let index = 0;
  
      while (index < materialPackagings.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_materialpackagings_by_shortnames.get({ materialPackagingNames: materialPackagings.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getMaterialsPool() {
      let materials: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.LookupCode?.toString())).map(ol => ol.LookupCode?.toString().trim())));
      let index = 0;
  
      while (index < materials.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_materials_by_lookupcodes.get({ materialLookupcodes: materials.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getMeasurementUnitsPool() {
      let dimensionUoms: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.DimensionUnit?.toString())).map(ol => ol.DimensionUnit?.toString())));
      let volumeUoms: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.VolumeUnit?.toString())).map(ol => ol.VolumeUnit?.toString())));
      let weightUoms: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.WeightUnit?.toString())).map(ol => ol.WeightUnit?.toString())));
  
      var units = dimensionUoms.concat(weightUoms, volumeUoms);
  
      let index = 0;
  
      while (index < units.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_measurementunits_by_shortnames.get({ measurementUnitShortNames: units.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: ExcelMaterialImport_excel_materials_packagings_import_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_materials_packagings_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_materials_packagings_import_grid.on_init');
  $grid.vars.projectId = 0
  
  $grid.topToolbar.linecount.hidden = true;
  }
  //#endregion private flows

  async $importExcel(fileInput: HTMLInputElement) {
    if(fileInput.files?.length !== 1) {
      throw new Error('Cannot import multiple files');
    }
    const file = fileInput.files[0];
    if(file.size > 15 * 1000 * 1000) {
      throw new Error('Cannot import a file with size greater than 15MB');
    }
    const reader: FileReader = new FileReader();
    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const ab: ArrayBuffer = e.target?.result as ArrayBuffer;
      const wb: WorkBook = readExcelFile(ab);
      await this.on_excel_import(wb);
    };
    reader.readAsArrayBuffer(file);
    fileInput.value = '';
  }

  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'ExcelMaterialImport_excel_materials_packagings_import_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
